import * as actionType from './ActionType';

export const setThreatMetrixSession = (sessionId) => ({
  type: actionType.SET_THREATMETRIX_SESSION_ID,
  payload: {
    sessionId
  }
});
